import { useRef } from 'react';

/**
 * Caches and return the latest non-null & non-undefined value.
 *
 * The null or undefined may be returned if no other value was provided.
 */
export function useLatestNonNilValue<T>(value: T): T {
  const latest = useRef<T>(value);

  if (value != null) {
    latest.current = value;
  }

  return latest.current;
}
